import table from "@/domains/local-db/account/syncUpdates/adapter";
import config from "@/domains/local-db/account/syncUpdates/config";
import { SyncModelData, SyncUpdate } from "@/store/sync/types";
import pRetry from "p-retry";

export const getAll = (): Promise<SyncUpdate<SyncModelData>[]> =>
  pRetry(() => table.getAllOrderedByFieldAsc(config.FIELD_COMMITTED_AT, { mayFail: true }));
